'use strict';

angular.module('shiftTraderApp')
  .factory('ShiftTradesResource', function ($resource, ServerUrls, TimeService, $injector) {
    var apiBase = ServerUrls.current.railsApi;

    if (_.contains(apiBase, ':')) {
      apiBase = apiBase.replace(':', '\\:');
    }

    var ShiftTrade = $resource(apiBase + 'shift_trades/:id', {id: '@id'});
    var WorkPeriods = $injector.get('WorkPeriods');
    var Users = $injector.get('Users');

    ShiftTrade.prototype.$initialize = function() {
      this.user = Users.initWithData(this.user);
      this.work_period = WorkPeriods.initWithData(this.work_period);
      if (!this.$isGiveaway()) {
        this.trade_work_period = WorkPeriods.initWithData(this.trade_work_period);
        this.trade_user = Users.initWithData(this.trade_user);
      }

      return this;
    };

    ShiftTrade.prototype.$currentStatus = function () {
      if (this.shift_trade_responses) {
        var sortedResponses = _.sortBy(this.shift_trade_responses, function(resp) {
          //sortBy is smallest->largest. calling moment.unix() returns microseconds from unix epoch.
          //multiplying by -1 makes the newest timestamps the larger numbers, reversing the sort
          return -1*moment(resp.created_at).unix();
        });
        var response = lodash.find(sortedResponses, function(response) {
          return response.acceptance_code && response.acceptance_code !== 30;
        });
        if (response && response.acceptance_code) {
          return response.acceptance_code;
        } else {
          return 0;
        }
      }
      return undefined;
    };

    ShiftTrade.prototype.$statusInWords = function(usr, canApprove) {
      if (this.$wasRejectedByInitiator() || this.$wasCancelledDueToShiftCancellation()) {
        return 'Cancelled';
      }

      if (this.$isApproved()) {
        return 'Approved';
      }

      if (this.$isDisapproved()) {
        return 'Disapproved';
      }
      if (this.$isGiveaway()) {
        if (!this.$isAccepted() && this.$calculateActive(true)) {
          return 'Waiting for taker...';
        } else if (!this.$isAccepted() && this.$isInThePast()) {
          return 'Expired';
        }
      } else { // not a giveaway
        var onlyMessages = _.reduce(_.map(this.shift_trade_responses, function(str) {
          return str.acceptance_code === 30 ? 0 : 1;
        }), function(val, num) {
          return val + num;
        });

        if (this.shift_trade_responses.length === 0 || onlyMessages === 0) { // no one has responded to the trade except with messages(possibly)
          if (this.$isInThePast()) {
            return 'Expired';
          } else {
            if (usr.id === this.trade_user.id) {
              //usr is the responder to the trade
              return 'Waiting for your response...';
            } else if (usr.id === this.user.id) {
              // if  usr is the initiator, and their trade is still active, and no one has responded just yet.
              return 'No response from ' + this.trade_user.name + ' yet...';
            } else {
              // This trade is still active, no one has responded just yet and usr is not involved.
              return 'No interest from ' + this.trade_user.name + ' yet...';
            }

          }
        }

        if (this.$isRejected()) {
          return 'Rejected';
        }
      }

      if (this.$isAccepted()) {
        if (this.$calculateActive(true)) {
          if (this.$isGiveaway()) {
            // is a giveaway
            if (usr.id === this.user.id ||
              _.any(this.shift_trade_responses, function(resp) {
                if (_.has(resp, 'user_id')) {
                  return resp.user_id === usr.id && resp.acceptance_code === 10;
                } else {
                  return resp.user.id === usr.id && resp.acceptance_code === 10;
                }
              })) {
              // usr is a part of the pickup (started it or accepted it)
              return 'Accepted, awaiting approval...';
            } else if (canApprove) {
              return 'Awaiting your approval...';
            } else {
              return 'Accepted';
            }
          } else {
            //not a giveaway
            if (usr.id === this.trade_user.id || usr.id === this.user.id ) {
              // usr is either initiator of trade or is recipient and has accepted
              return 'Accepted, awaiting approval...';
            } else if (canApprove) {
              return 'Awaiting your approval...';
            } else {
              return 'Accepted';
            }
          }
        } else {
          return 'Expired';
        }
      }
      return 'Did not match: ' + this.id;   //replace with  'Did not match: ' + this.id
    };

    ShiftTrade.prototype.$type = function(me) {
      if (this.$isGiveaway()) {
        // if a giveaway...
        if (this.$isInitiator(me)) {
          return 'queue_pickup_request_from_me';
        } else {
          return 'queue_pickup_request';
        }
      } else {  //not a giveaway
        if (this.$isInitiator(me)) {
          return 'queue_trade_request_from_me';
        } else {
          return 'queue_trade_request';
        }
      }
    };

    ShiftTrade.prototype.$isInitiator = function(me) {
      return (me.id === this.user.id);
    };

    ShiftTrade.prototype.$isReceiver = function(usr) {
      return ((!_.isNull(this.trade_user) && usr.id === this.trade_user.id) ||
        _.any(this.shift_trade_responses, function(resp) {
          if (_.has(resp, 'user_id')) {
            return usr.id === resp.user_id && resp.acceptance_code === 10;
          } else {
            return usr.id === resp.user.id && resp.acceptance_code === 10;
          }
        }));
    };

    ShiftTrade.prototype.$tradeDirection =function(me) {
      //assuming "Me" is on the left hand side.
      //false == left arrow; true = right arrow
      return this.$isInitiator(me);
    };

      ShiftTrade.prototype.$isGiveaway = function() {
        // if trade_work_period_id == null and trade_user_id == null then trade is a giveaway
        return (this.trade_user === null && this.trade_work_period === null) ||
            (this.trade_user_id === null && this.trade_work_period_id === null);
      };

    ShiftTrade.prototype.$calculateActive = function(falseOnPast) {
      //shift_trades now have an active property, but just as a double check (especially when lots of updates are occurring)
      // if a shift_trade_response exists with APPROVED status then inactive
      // TODO: ANALYZE... if a shift_trade_response exists with DISAPPROVED status && trade is giveaway && shift_trade_response.shift_trade_response_id == null then inactive
      // if shift_trade initiating user filed a shift_trade_response with REJECTED status then inactive (cancelled by initiator)
      // if (in a directed trade) a shift_trade_response exists with DISAPPROVED status then inactive
      // if (in a directed trade) the trade_user_id user files a shift_trade_response with REJECTED status then inactive

      var response;
      if(this.shift_trade_responses) {
        //if a shift_trade_response exists with APPROVED status then inactive
        if(this.$isApproved()) {
          return false;
        }

        //if shift_trade initiating user filed a shift_trade_response with REJECTED status then inactive
        if(this.$wasRejectedByInitiator()) {
          return false;
        }

        if (this.$wasCancelledDueToShiftCancellation()) {
          return false;
        }

        if(this.$isGiveaway()) {
          //if a shift_trade_response exists with DISAPPROVED status && trade is giveaway && shift_trade_response.shift_trade_response_id == null then inactive
          response = _.find(this.shift_trade_responses, function(resp) {
            return resp.acceptance_code === 21 && _.isUndefined(this.shift_trade_response_id);
          }, this);
          //if a result was found (return is defined) then trade is inactive
          if(!_.isUndefined(response)) {
            return false;
          }
        } else {
          //directed trade checks
          //if (in a directed trade) the trade_user_id user files a shift_trade_response with REJECTED status then inactive
          response = _.find(this.shift_trade_responses, function(resp) {
            var trade_user_id = _.isUndefined(this.trade_user_id) ? this.trade_user.id : this.trade_user_id;
            if (_.has(resp, 'user_id')) {
              return resp.acceptance_code === 11 && trade_user_id === resp.user_id;
            } else {
              return resp.acceptance_code === 11 && trade_user_id === resp.user.id;
            }
          }, this);
          if(!_.isUndefined(response)) {
            return false;
          }

          // if (in a directed trade) a shift_trade_response exists with DISAPPROVED status then inactive
          response = _.find(this.shift_trade_responses, function(resp) {
            return resp.acceptance_code === 21;
          }, this);
          if(!_.isUndefined(response)) {
            return false;
          }
        }
      } else {
        return false; // don't think this is really necessary
      }

      //alright, well you got through most of the mine field. Now check if trade is expired
      if (this.$isInThePast() && angular.isDefined(falseOnPast)) {
        return false;
      }
      return true; //you got through the minefield!
    };

    ShiftTrade.prototype.$isInThePast = function() {
      var now = TimeService.getNowInStoreTime();
      if (this.$isGiveaway()) {
        //check to make sure that the shift being given away has not started yet
        return this.work_period.start_time.isBefore(now);
      } else {
        return this.work_period.start_time.isBefore(now) || this.trade_work_period.start_time.isBefore(now);
      }
    };

    ShiftTrade.prototype.$isApproved = function() {
      if(this.shift_trade_responses) {
        var response = _.find(this.shift_trade_responses, function(resp) {
          return resp.acceptance_code && resp.acceptance_code === 20;
        });
        return !_.isUndefined(response);
      } else {
        return false;
      }
    };

    ShiftTrade.prototype.$isDisapproved = function() {
      if(this.shift_trade_responses) {
        var response = _.find(this.shift_trade_responses, function(resp) {
          return resp.acceptance_code && resp.acceptance_code === 21;
        });
        return !_.isUndefined(response);
      } else {
        return false;
      }
    };

    ShiftTrade.prototype.$isAccepted = function() {
      if(this.shift_trade_responses) {
        var response = _.find(this.shift_trade_responses, function(resp) {
          return resp.acceptance_code && resp.acceptance_code === 10;
        });
        return !_.isUndefined(response);
      } else {
        return false;
      }
    };

    ShiftTrade.prototype.$isRejected = function() {
      if(this.shift_trade_responses) {
        var response = _.find(this.shift_trade_responses, function(resp) {
          return resp.acceptance_code && resp.acceptance_code === 11;
        });
        return !_.isUndefined(response);
      } else {
        return false;
      }
    };

    ShiftTrade.prototype.$isRejectedBy = function(usr) {
      if(this.shift_trade_responses) {
        var response = _.find(this.shift_trade_responses, function(resp) {
          if (_.has(resp, 'user_id')) {
            return resp.acceptance_code && resp.acceptance_code === 11 && resp.user_id === usr.id;
          } else {
            return resp.acceptance_code && resp.acceptance_code === 11 && resp.user.id === usr.id;
          }
        });
        return !_.isUndefined(response);
      } else {
        return false;
      }
    };

    ShiftTrade.prototype.$wasRejectedByInitiator = function() {

      if(this.shift_trade_responses) {
        var userInTrade, respUser;
        var response = _.find(this.shift_trade_responses, function(resp) {
          if(_.has(resp, 'user_id')) {
            respUser = resp.user_id;
          } else {
            respUser = resp.user.id;
          }

          if(_.has(this, 'user_id')) {
            userInTrade = this.user_id;
          } else {
            userInTrade = this.user.id;
          }
          return resp.acceptance_code === 11 && respUser === userInTrade;
        }, this);
        return !_.isUndefined(response);
      } else {
        return false;
      }
    };

    ShiftTrade.prototype.$wasCancelledDueToShiftCancellation = function() {
      if(this.shift_trade_responses) {
        var response = _.find(this.shift_trade_responses, function(resp) {
          return resp.acceptance_code === 40;
        }, this);
        return !_.isUndefined(response);
      } else {
        return false;
      }
    };

    ShiftTrade.prototype.$isCancelled = function() {
      return this.$wasRejectedByInitiator() || this.$wasCancelledDueToShiftCancellation();
    };


    ShiftTrade.prototype.$acceptingUser = function() {
      if(this.shift_trade_responses && this.shift_trade_responses.length > 0) {
        var response = _.find(this.shift_trade_responses, function(resp) {
          return resp.acceptance_code && resp.acceptance_code === 10;
        }, this);
        if (angular.isDefined(response)) {
          return response.user;
        } else {
          return undefined;
        }
      } else {
        return undefined;
      }
    };

    ShiftTrade.prototype.$receivingUser = function() {
      if (!this.$isGiveaway()) {
        return this.trade_user;
      } else {
        return this.$acceptingUser();
      }
    };

    ShiftTrade.prototype.$approvingUser = function() {
      if(this.shift_trade_responses && this.shift_trade_responses.length > 0) {
        var response = _.find(this.shift_trade_responses, function(resp) {
          return resp.acceptance_code && resp.acceptance_code === 20;
        }, this);
        if (angular.isDefined(response)) {
          return response.user;
        } else {
          return undefined;
        }
      } else {
        return undefined;
      }
    };

    ShiftTrade.prototype.$disapprovingUser = function() {
      if(this.shift_trade_responses && this.shift_trade_responses.length > 0) {
        var response = _.find(this.shift_trade_responses, function(resp) {
          return resp.acceptance_code && resp.acceptance_code === 21;
        }, this);
        if (angular.isDefined(response)) {
          return response.user;
        } else {
          return undefined;
        }
      } else {
        return undefined;
      }
    };

    return ShiftTrade;
  });
